import { useState } from 'react';
import type { FetcherWithComponents } from 'react-router';

import InformationIcon from '~/assets/icons/Information';
import { Button } from '~/components/Button';
import Link from '~/components/Link';
import type { NotificationData } from '~/components/ProductNotificationButton';
import SignUpMethodEvent from '~/events/SignUpMethodEvent';
import useRootData from '~/hooks/useRootData';
import useUser from '~/hooks/useUser';
import { buildNotificationProducts } from '~/utils/browser';
import { getPageViewId } from '~/utils/navigationContext';

import type { FetcherData } from '.';

type Props = {
  fetcher: FetcherWithComponents<FetcherData>;
  product: NotificationData;
  sizes: string[];
};

export default function EmailEntry({ fetcher, product, sizes }: Props) {
  return (
    <>
      <EmailInput product={product} fetcher={fetcher} sizes={sizes} />
      <TnCBlurb />
    </>
  );
}

function EmailInput({ fetcher, product, sizes }: Props) {
  const [email, setEmail] = useState('');
  const user = useUser();
  const { isBot } = useRootData();

  const products = buildNotificationProducts(product?.id, sizes);

  return (
    <fetcher.Form
      className="flex w-full flex-col gap-2 rounded-lg bg-grey-tile p-2"
      action="/bolt/register"
      method="post"
    >
      <input type="hidden" value={product?.legacyId} name="legacyProductId" />
      <input type="hidden" value={JSON.stringify(products)} name="products" />
      <input type="hidden" value={user.guestId} name="guestId" />
      <input type="hidden" value={getPageViewId() ?? ''} name="viewId" />
      <input type="hidden" value="restock" name="action" />
      <div className="flex w-full flex-row gap-2">
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full rounded-lg border border-grey-divide p-4"
          placeholder="Your email address"
          name="email"
        />
        {email && (
          <Button
            type="submit"
            variant="forest"
            className="!w-auto"
            onClick={() =>
              new SignUpMethodEvent({
                buttonName: 'SIGN_UP_EMAIL',
                isBot,
                pagePosition: 'Sign in modal',
                tempContext: 'Notification Flow'
              }).send()
            }
          >
            Next
          </Button>
        )}
      </div>
      {fetcher.data?.errors?.conflict && (
        <span className="flex w-full flex-row items-center justify-center gap-2 text-xs text-red-alert">
          <InformationIcon circleStroke="#D71225" fill="#D71225" />
          Email already in use, please go back to log in or reset your password
        </span>
      )}
    </fetcher.Form>
  );
}
function TnCBlurb() {
  return (
    <span className="block text-xs text-grey-hide">
      <span>By continuing you agree to our </span>
      <Link className="underline" to="/terms-and-conditions/">
        terms & conditions
      </Link>{' '}
      and{' '}
      <a
        className="underline"
        target="_blank"
        rel="noopener noreferrer"
        href="https://app.privasee.io/privacy-portal/64ac2c059f43880013f2faf0"
      >
        privacy policy
      </a>
    </span>
  );
}
